/**
 * The workbook's eight columns, under two headings: the year against the prior
 * year (This year, Prior year, Variance, Var %) and the year against the plan
 * (This year, Plan, Variance, Var %). Every Recap table but the rankings and
 * Janus is this one, so a figure reads the same wherever it appears.
 */

import type { ReactNode } from 'react'

import { amount, percent, tone } from './format'
import type { Figures } from './tree'
import { variance } from './tree'

export interface Labels {
  readonly cy: string
  readonly py: string
  readonly plan: string
  readonly money: boolean
}

export interface TableRow {
  readonly id: string
  readonly label: ReactNode
  readonly figures: Figures
  readonly depth?: number
  readonly total?: boolean
}

export function CompareTable({
  first,
  rows,
  labels,
}: {
  first: string
  rows: readonly TableRow[]
  labels: Labels
}) {
  return (
    <div className="srp-scroll">
      <table className="srp-table rcp-table">
        <thead>
          <tr>
            <th rowSpan={2}>{first}</th>
            <th colSpan={4} className="srp-group">
              {labels.cy} vs {labels.py}
            </th>
            <th colSpan={4} className="srp-group">
              {labels.cy} vs {labels.plan}
            </th>
          </tr>
          <tr>
            <th className="cell-number">{labels.cy}</th>
            <th className="cell-number">{labels.py}</th>
            <th className="cell-number">Variance</th>
            <th className="cell-number">Var %</th>
            <th className="cell-number">{labels.cy}</th>
            <th className="cell-number">{labels.plan}</th>
            <th className="cell-number">Variance</th>
            <th className="cell-number">Var %</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => {
            const { cy, py, plan } = row.figures
            const vsPy = variance(cy, py)
            const vsPlan = variance(cy, plan)
            return (
              <tr key={row.id} className={row.total === true ? 'srp-total' : undefined}>
                <td
                  className="srp-wrap"
                  style={{
                    paddingLeft: `${String(0.35 + (row.depth ?? 0) * 1.1)}rem`,
                  }}
                >
                  {row.label}
                </td>
                <td className="cell-number">{amount(cy, labels.money)}</td>
                <td className="cell-number">{amount(py, labels.money)}</td>
                <td className={`cell-number ${tone(vsPy.amount)}`}>{amount(vsPy.amount, labels.money)}</td>
                <td className={`cell-number ${tone(vsPy.amount)}`}>{percent(vsPy.pct)}</td>
                <td className="cell-number">{amount(cy, labels.money)}</td>
                <td className="cell-number">{amount(plan, labels.money)}</td>
                <td className={`cell-number ${tone(vsPlan.amount)}`}>
                  {amount(vsPlan.amount, labels.money)}
                </td>
                <td className={`cell-number ${tone(vsPlan.amount)}`}>{percent(vsPlan.pct)}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}
